__turbopack_context__.v({
  "sponsorship_text": "SponsorshipText-module-scss-module__sUywgG__sponsorship_text",
});
